export default "__VITE_ASSET__D8nw$r40__"